import React, { useState, useEffect } from "react";

import "./../styles/CustomerService.scss";
import pppng from "../img/pppng.png";
import mailpngg from "../img/mailpngg.png";
import telefonpng from "../img/telefonpng.png";
import locationpng from "../img/locationpng.png";
import positionpng from "../img/positionpng.png";
import inputareapng from "../img/inputareapng.png";
import Api from "../common/api";

const CustomerService = () => {

  const lang = localStorage.getItem("lang");
  const [cities, setCities] = useState([])
  const [towns, setTowns] = useState([])
  const [info, setInfo] = useState(false)
  React.useEffect(() => {
    Api.get("/home/getcities/").then((res) => {
      setCities(res.data.cities)
    });
  }, []);

  const selectedCity = (e) => {
    Api.get("/home/GetCityTowns/"+e).then((res) => {
      setTowns(res.data.towns)
    });
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    let data = {
      email:e.target.email.value,
      name:e.target.name.value,
      company:e.target.company.value,
      companyphone:e.target.companyphone.value,
      //burası hakkında blog yazılır!!
      city:e.target.city.options[e.target.city.selectedIndex].text,
      town:e.target.town.value,
      subject:e.target.subject.value,
      message:e.target.message.value,
    }
    
    Api.post("/home/SendMail/",data).then((res) => {
      setInfo(true)
    });
    
  
  }

  return (

    <form onSubmit={handleSubmit}>
      {info ? (
        <p className="info-content">İstek Başarıyla Gönderilmiştir</p>
      ) :""}
      <div className="form-section">
        <div className="input-container">
          <input className="form-input" placeholder={lang == "en" ? "Name - Surname" : "Adınız - Soyadınız"} name="name" />
          <img src={pppng} alt="asda" />
          <span className="more-left"></span>
        </div>
        <div className="input-container">
          <input className="form-input" placeholder="xxx@xxxx.xxx" name="email" />
          <img src={mailpngg} alt="asda" />
          <span className="more-left"></span>
        </div>
        <div className="input-container">
          <input className="form-input" placeholder={lang == "en" ? "Company Name" : "Şirket İsmi"} name="company" />
          <img src={positionpng} alt="asda" />
          <span className="more-left"></span>
        </div>
        <div className="input-container">
          <input className="form-input" placeholder={lang == "en" ? "Business Phone" : "Şirket Telefonu"} name="companyphone" />
          <img src={telefonpng} alt="asda" />
          <span className="more-left"></span>
        </div>
        <div className="input-container">
          <select
            className="form-input-select "
            id="city"
            name="city"
            onChange={e => selectedCity(e.target.value)}
          >
            <option  value="s">
            {lang == "en" ? "City" : "İl Seçiniz"}
            </option>
            {cities ? cities.map((data) => (
              <option value={data.Value} city={data.Text}>
              {data.Text}
              </option>
            )):""}
          </select>
          <span className="select-span"></span>
          <img src={locationpng} alt="asda" />
        </div>
        <div className="input-container">
          <select
            className="form-input-select "
            id="town"
            name="town"
          >
            <option value="s">
            {lang == "en" ? "District" : " İlçe Seçiniz"}
            </option>
            {towns ? towns.map((data) => (
              <option value={data.Text}>
              {data.Text}
              </option>
            )):""}
          </select>
          <span className="select-span"></span>
          <img src={locationpng} alt="asda" />
        </div>
        <div className="input-group full-width ">
          <div className="icon">
            <img src={inputareapng} alt="sd" />
            <span src="more-left"></span>
          </div>
          <input className="form-input"  name="subject" placeholder={lang == "en" ? "Subject" : "Konu"} />
        </div>
        <div className="input-group full-width ">
          <div className="icon">
            <img src={inputareapng} alt="sd" />
            <span src="more-left"></span>
          </div>
          <textarea placeholder={lang == "en" ? "Message" : "Mesaj"} name="message" />
        </div>
      </div>
      <div className="input-check-one">
        <input type="checkbox" />
        {lang  == "en" ? (
        <p>
          I wish to receive e-mails in line with the terms laid down in the   <a
            href="https://sankoenerji.com.tr/Uploads/MediaCenter/ENKO_Acik_Riza_Metni.pdf"
            target="_blank"
            style={{ color: "#255e85", textDecoration: "underline" }}
          >Consent Document </a> in order to be informed about important campaigns.
        </p>):(
          
        <p>
        Önemli kampanyalardan haberdar olmak için{" "}
        <a
          href="https://sankoenerji.com.tr/Uploads/MediaCenter/ENKO_Acik_Riza_Metni.pdf"
          target="_blank"
          style={{ color: "#255e85", textDecoration: "underline" }}
        >
          Rıza Metni</a>{" "}
        kapsamında elektronik ileti almak istiyorum.
      </p>

        )}
      </div>
      <div className="input-check-two">
        <input type="checkbox" />
         {lang == "en" ? ( 
         
         <p>
              I have read and understood the
          <a
            target="_blank"
            href="https://sankoenerji.com.tr/Uploads/MediaCenter/ENKO_Elektrik-Almak-Istiyorum_-KVKK_Metni.pdf"
            style={{
              color: "#255e85",
              textDecoration: "underline",
              margin: "0 5px",
            }}
          >
           Clarification Notice.
          </a>
        </p>
        ):(

          <p>
            <a
              target="_blank"
              href="https://sankoenerji.com.tr/Uploads/MediaCenter/ENKO_Elektrik-Almak-Istiyorum_-KVKK_Metni.pdf"
              style={{
                color: "#255e85",
                textDecoration: "underline",
                margin: "0 5px",
              }}
            >
              Aydınlatma Metnini
            </a>
            okudum ve anladım.
          </p>
        )}
      </div>
      <button className="submit-btn right">{lang == "en" ? "Send" : "Gönder"}</button>
    </form>
  );
};

export default CustomerService;
